// extracted by mini-css-extract-plugin
export default {"clients":"ViewClientsPage_clients__LnW77","main":"ViewClientsPage_main__SHJDY"};